<template>
  <div id="conditions">

    <!--<div class="hero is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">Conditions</h1>
        </div>
      </div>
    </div>-->

    <div class="container">
      <section class="intro section">
        <h2 class="title">{{ $t('conditions.intro.title') }}</h2>
        <div class="content" v-html="$t('conditions.intro.body')"></div>
      </section>

      <section class="tos section">
        <h2 class="title">{{ $t('conditions.terms.title') }}</h2>
        <div class="content" v-html="$t('conditions.terms.body')"></div>
      </section>

      <section class="privacy section">
        <h2 class="title">{{ $t('conditions.privacy.title') }}</h2>
        <div class="content" v-html="$t('conditions.privacy.body')"></div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.$t('conditions.title'),

      meta: [
        { name: 'description', content: this.$t('conditions.description') }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Conditions.vue?2eed27e4